<template>
    <v-switch color="success" :value="value" v-model="internal" :label="label">
    </v-switch>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["value", "label"],
  data() {
    return {
      internal: ""
    };
  },
  created() {
    this.internal = this.value;
  },
  watch: {
    value() {
      this.internal = this.value;
    },
    internal() {
      this.$emit("input", this.internal);
    }
  }
};
</script>

